var render = function (_h,_vm) {var _c=_vm._c;return _c('transition',{attrs:{"name":"background-mask-transition"}},[(_vm.props.show)?_c('div',{staticClass:"background-mask-container"},[_c('div',{staticClass:"background-mask",on:{"click":_vm.listeners.click}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }